import BaseApi from "./baseAPI";

class FacultyAPI extends BaseApi{
  get entity() {
    return {
      route: `/`,
    }
  }

  info(){
    return new Promise((resolve, reject) => {
      return this.request.get(`/get-faculty`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new FacultyAPI()
